module.exports = __webpack_public_path__ + "img/State=11.f1bf0e54.svg";